(function ($) {

    ///////////////      INITIALIZATION     //////////////////////
    this.init = function () {

        initKeyNav();

        // EVENT HANDLING //

        // When you enter a level1 item - make sure we pop level 2 (and close all sibling level 2 menus)
        $(".mainnav .level1-item").mouseenter(enterNav)
            .mouseleave(leaveNav);

        // When we enter a level1 item or any child within it, if we do not enter another child in that level1 item, close the nav
        $(".mainnav .level1-item").focusin(enterNav)
            .focusout(leaveNav);

        // Level 1, 2, and 3 keyboard handler
        $(".mainnav").find(".level1-item-link, .level2-item-link, .level3-item-link, .level2-item-promolink, .level2-right-promo, .menupromo").on("keydown", menuKeyNav);

        // label all business links as business.
        $(".mainnav").find(".level2").eq(1).find("a").each(function () {
            if (!$(this).text().startsWith("Business")) {
                $(this).attr("aria-label", "Business: " + $(this).text());
            }
        });

    };

    ///////////////      KEYBOARD NAV      ///////////////////////
    function initKeyNav() {
        var that,
            y = 0;

        $(".mainnav .level1-item").each(function (i) {
            that = this;
            $(this).find(".level1-item-link").attr("nav-index-x", i).attr("nav-index-y", y);
            $(this).find(".level2-item").each(function () {
                y++;
                $(this).find(".level2-item-link").attr("nav-index-x", i).attr("nav-index-y", y);

                $(this).find(".level3-item").each(function (k) {
                    y++;
                    $(this).find(".level3-item-link").attr("nav-index-x", i).attr("nav-index-y", y);
                });

            });
            $(this).find(".menupromo").each(function (k) {
                y++;
                $(this).attr("nav-index-x", i).attr("nav-index-y", y);
            });

            y = 0;
        });
    }
    function menuKeyNav(event) {

        var $item, itemX, itemY;

        stopThaProp(event);

        $item = $(event.currentTarget);
        itemX = $(event.currentTarget).attr("nav-index-x") - 0;
        itemY = $(event.currentTarget).attr("nav-index-y") - 0;


        switch (event.originalEvent.which) {
            case 37:
                // left
                if (itemX > 0) {
                    $(".mainnav").find('[nav-index-x="' + (itemX - 1) + '"][nav-index-y="0"]').focus();
                }
                break;
            case 38:
                // up 
                if (itemY > 0) {
                    $(".mainnav").find('[nav-index-x="' + itemX + '"][nav-index-y="' + (itemY - 1) + '"]').focus();
                }
                event.preventDefault();

                break;
            case 39:
                $(".mainnav").find('[nav-index-x="' + (itemX + 1) + '"][nav-index-y="0"]').focus();
                break;
            case 40:
                // down 
                $(".mainnav").find('[nav-index-x="' + itemX + '"][nav-index-y="' + (itemY + 1) + '"]').focus();
                event.preventDefault();

                break;
            case 9:
                // tab
                $(".main").find("a").first().focus();
                event.preventDefault();

                break;
        }
    }


    //////////////        FOCUS HANDLING   ///////////////////////
    function enterNav(event) {
        closeLevel2();
        openLevel2(event);
    }
    function leaveNav(event) {
        closeLevel2();
    }
    function openLevel2(event) {
        if ($(event.currentTarget).hasClass("level1-item")) {
            $(event.currentTarget).find(".level1-item-link").attr("aria-expanded", "true");
            $(event.currentTarget).find(".level2").addClass("level2-visible").removeClass("level2-hidden");
        } else {
            $(event.currentTarget).parents(".level1-item").find(".level2").addClass("level2-visible").removeClass("level2-hidden");
        }
    }
    function closeLevel2() {
        $(".mainnav").find(".level1-item-link[aria-expanded=true]").attr("aria-expanded", "false");
        $(".level2-visible").addClass("level2-hidden").removeClass("level2-visible");
    }

    //////////////       UTILITY       ///////////////////////
    function stopThaProp(event) {
        event.stopPropagation();
    }

    this.init();

})(jQuery);